/** A schema + default values for what `this.data.relationships` looks like, */
const FacetSearchCompanyRelationshipSlice = {
  authorizedSalesForce: false,
  selected: [],
  salesforceCurrentlyProcessing: false
}

window.FacetSearchCompanyRelationshipSlice = FacetSearchCompanyRelationshipSlice
export { FacetSearchCompanyRelationshipSlice }